module.exports = __webpack_public_path__ + "static/media/FireWork_txt.acc8959e.png";